import { render, staticRenderFns } from "./sentry_error_stack_trace.vue?vue&type=template&id=0ade121c&"
import script from "./sentry_error_stack_trace.vue?vue&type=script&lang=js&"
export * from "./sentry_error_stack_trace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports